import { render } from "./SVGDragNDrop.vue?vue&type=template&id=c4ce3ec0"
import script from "./SVGDragNDrop.vue?vue&type=script&lang=js"
export * from "./SVGDragNDrop.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__